<form [formGroup]="form" class="row">
	<mat-form-field appearance="fill" class="col-lg-12">
		<mat-label>{{label.length > 0 ? label : 'Select Service' + (isMultiple ? '(s)' : '')}}
		</mat-label>
		<mat-select formControlName="serviceSelect" [multiple]="isMultiple" (openedChange)="onOpen($event)"
			[panelClass]="'panel-location-filter'" *ngIf="this.isMultiple" [required]="required">

			<div class="padding-md text-center row gx-0">
				<div *ngIf="isMultiple" [ngClass]="{ 'col-lg-7': !activeOnly, 'col-lg-6': activeOnly }">
					<button color="primary" mat-raised-button (click)="selectAll()">
						Select All
					</button>
					<button color="" mat-raised-button (click)="selectAll('Active')" [hidden]="activeOnly"
						class="margin-horizontal-xs">
						Active Only
					</button>
					<button color="" mat-raised-button (click)="selectAll('Inactive')" [hidden]="activeOnly">
						Inactive Only
					</button>
				</div>
				<div [ngClass]="{ 'col-lg-5': !activeOnly, 'col-lg-6': activeOnly }">
					<button color="accent" mat-raised-button (click)="deSelectAll()">
						Deselect <span *ngIf="isMultiple">All</span>
					</button>
				</div>
			</div>

			<div class="padding-horizontal-md row gx-0">
				<mat-form-field class="col-lg-12">
					<mat-label>
						Filter
					</mat-label>
					<input matInput type="string" placeholder="by name" formControlName="filter"
						(keydown)="$event.stopPropagation()" #filterRef />
				</mat-form-field>
			</div>

			<div class="text-center padding-md" *ngIf="isLoading">
				<mat-icon>
					<mat-spinner diameter="13"> </mat-spinner>
				</mat-icon>
				Loading
			</div>

			<mat-option [hidden]="true">None</mat-option>
			<div class="scrollable-panel-location" [hidden]="isLoading">
				<mat-option class="scrollable-panel-location" *ngFor="let partyService of filteredPartyServices"
					[value]="partyService">
					{{partyService.SERVICE_CODE}} - {{partyService.SERVICE_NAME}}
					{{partyService.PARTY_SERVICE_STATUS_TYPES_ID === 1 ? '' : '- *Inactive*'}}
				</mat-option>
			</div>
		</mat-select>

		<mat-select placeholder="Select Service" formControlName="serviceSelect" *ngIf="!this.isMultiple"
			(openedChange)="onOpen($event)" [required]="required">

			<div class="padding-md text-center row gx-0">
				<div class="col-lg-12">
					<button color="accent" mat-raised-button (click)="deSelectAll(); close();">
						Deselect
					</button>
				</div>
			</div>

			<div class="text-center padding-md" *ngIf="isLoading">
				<mat-icon>
					<mat-spinner diameter="13"> </mat-spinner>
				</mat-icon>
				Loading
			</div>

			<mat-option [hidden]="true">Select</mat-option>
			<div [hidden]="isLoading">
				<mat-option *ngFor="let partyService of this.filteredPartyServices" [value]="partyService">
					{{partyService.SERVICE_CODE}} - {{partyService.SERVICE_NAME}}
					{{partyService.PARTY_SERVICE_STATUS_TYPES_ID === 1 ? '' : '- *Inactive*'}}
				</mat-option>
			</div>
		</mat-select>
	</mat-form-field>
</form>